module.exports = __webpack_public_path__ + "img/12-small.211f7060.png";